import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import { makeListResults } from 'test-util/api/response';
import {
  getDraftMessage,
  getMessage,
  messages,
} from './fixtures/connect-domain.fixture';

const domain = 'incentivio-connect-domain';

export const listMessagesMock = fn =>
  rest.get(
    `${getEnv('REACT_APP_ADMIN_API_URL')}/${domain}/clients/:clientId/messages`,
    fn,
  );

export const updateMessageMock = fn =>
  rest.put(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/clients/:clientId/merchants/:merchantId/messages2/:messageId`,
    fn,
  );

export const deleteMessageMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/clients/:clientId/merchants/:merchants/messages/:messageId`,
    fn,
  );

export const getMessageMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/clients/:clientId/messages/:messageId`,
    fn,
  );

export const createDraftMessageMock = fn =>
  rest.post(`${getEnv('REACT_APP_ADMIN_API_URL')}/${domain}/draftmessages`, fn);

export const updateDraftMessageMock = fn =>
  rest.put(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/draftmessages/:draftMessageId`,
    fn,
  );

export const getDraftMessageMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/draftmessages/:draftMessageId`,
    fn,
  );

export const deleteDraftMessageMock = fn =>
  rest.delete(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/draftmessages/:draftMessageId`,
    fn,
  );

export const publishDraftMessageMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/draftmessages/:draftMessageId/publish`,
    fn,
  );

export const copyMessageAsDraftMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/messages/:messageId/copyasdraft`,
    fn,
  );

export const copyDraftMessageAsDraftMock = fn =>
  rest.post(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/draftmessages/:draftMessageId/copyasdraft`,
    fn,
  );

export const handlers = () => [
  listMessagesMock((req, res, ctx) => {
    const messagestatus = req.url.searchParams.get('messagestatus');
    const statuses = messagestatus ? messagestatus.split(',') : null;
    const filtered = statuses
      ? messages.messages.filter(m => statuses.includes(m.messageStatus))
      : messages.messages;
    return res(
      ctx.json(
        makeListResults(filtered, req.url.searchParams, {
          listName: 'messages',
        }),
      ),
    );
  }),
  updateMessageMock((_req, res, ctx) => {
    return res(ctx.json({}));
  }),
  deleteMessageMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),
  getMessageMock((_req, res, ctx) => {
    return res(ctx.json(getMessage));
  }),
  createDraftMessageMock((_req, res, ctx) => {
    return res(
      ctx.json({
        draftMessageId: '00000000-0000-0000-0000-000000000002',
      }),
    );
  }),
  updateDraftMessageMock((_req, res, ctx) => {
    return res(ctx.json({}));
  }),
  getDraftMessageMock((_req, res, ctx) => {
    return res(ctx.json(getDraftMessage));
  }),
  deleteDraftMessageMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),
  publishDraftMessageMock((_req, res, ctx) => {
    return res(ctx.json({ messageId: '00000000-0000-0000-0000-000000000001' }));
  }),
  copyMessageAsDraftMock((_req, res, ctx) => {
    return res(
      ctx.json({
        draftMessageId: '00000000-0000-0000-0000-000000000003',
      }),
    );
  }),
  copyDraftMessageAsDraftMock((_req, res, ctx) => {
    return res(
      ctx.json({
        draftMessageId: '00000000-0000-0000-0000-000000000004',
      }),
    );
  }),
];
